<template functional>
  <input
    type="email"
    class="input"
    :class="$options.bindClass(data)"
    v-bind="$options.bindAttrs(data)"
    v-on="$options.bindListeners(listeners)"
    :ref="props.inputRef"
    :value="props.value"
    @input="e => $options.setValue(parent, listeners, e)"
  >
</template>

<script>
import Base from './control-base'

export default {
  name: 'ControlEmail',
  mixins: [Base],
}
</script>

